export default __webpack_public_path__ + "static/media/Estrela.185faa3b.png";